export default __webpack_public_path__ + "static/media/pre_step2.254d59cb.png";